/**
 * Telefone por OPERAÇÃO (venda × locação) nos botões de WhatsApp — gate por codsite (SD-0049, cs2532, 03/11/2026).
 *
 * Generaliza a regra que o cs1791 tem fixa no código (números literais em 4 arquivos): aqui os números vêm do
 * CADASTRO da imobiliária (Marketing › Meu site › Empresa & contato): venda = Telefone 1, locação = Telefone 3
 * (cai no 1 se o 3 estiver vazio). O 1791 continua com o bloco dele, intocado. Fora da lista nada muda.
 *
 * Operação do imóvel segue o critério já usado pelo site: só locação → 'locacao'; venda ou venda+locação → 'venda'.
 * O número da operação vale SEMPRE (mesmo com corretor na ficha), igual ao 1791 — pedido da cliente: "quando a
 * operação for venda os botões direcionam para o telefone de vendas".
 */
export type OperacaoTelefone = 'venda' | 'locacao';

export const TELEFONE_POR_OPERACAO_CODSITES: ReadonlySet<number> = new Set([2532]);

export function temTelefonePorOperacao(site: any): boolean {
    return TELEFONE_POR_OPERACAO_CODSITES.has(Number(site?.id));
}

export function telefoneOperacao(site: any, operacao: OperacaoTelefone): string {
    const d = site?.Dados || {};
    if (operacao === 'locacao') return String(d.tel3 || d.tel1 || '');
    return String(d.tel1 || '');
}

export function rotuloOperacao(site: any, operacao: OperacaoTelefone): string {
    const d = site?.Dados || {};
    if (operacao === 'locacao') return String(d.tel3_nome || 'Locação');
    return String(d.tel1_nome || 'Vendas');
}

/** Menu Venda/Locação do flutuante: no gate, exige os dois WhatsApps rotulados (tel1 = venda, tel3 = locação). */
export function menuOperacaoDisponivel(site: any): boolean {
    const d = site?.Dados || {};
    return temTelefonePorOperacao(site) && !!d.tel1_whats && !!d.tel3_whats && !!d.tel1_nome && !!d.tel3_nome;
}
